<template>
  <b-row>
    <b-col md="3" class="mb-3 mb-md-0" v-if="isSearch">
      <div class="filter-wrapper border rounded">
        <b-input-group prepend=" ">
          <b-form-input
            placeholder="Search"
            v-model="search"
            @input="applySearch"
          >
          </b-form-input>
        </b-input-group>
      </div>
    </b-col>
    <b-col md="2" class="mb-3 mb-md-0" v-if="isStatus">
      <b-dropdown
        id="dine-in-status-filter"
        :text="statusFilterDisplayText"
        class="w-100 text-left"
        variant="default"
        toggle-class="bg-white shadow-none border d-inline-flex align-items-center justify-content-between"
        menu-class="p-0"
      >
        <b-dropdown-item
          v-for="(status, statusIndex) of statusOptions"
          :key="`status-filter-${statusIndex}`"
          @click="selectedStatusFilter = status.value"
          class="px-2 d-flex"
        >
          <span class="d-inline-block selected-icon-container mr-2">
            <img
              src="@/assets/images/checked-symbol.svg"
              :alt="status.label"
              width="12"
              v-if="selectedStatusFilter === status.value"
            />
          </span>
          {{ status.label }}
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
    <b-col class="text-left text-md-right mb-3 mb-md-0" v-if="isAddTable">
      <b-button variant="primary" @click="handleAddTable" class="rounded-pill"
        >+ Add new table</b-button
      >
    </b-col>
  </b-row>
</template>

<script>
import { defineComponent, ref, watch, computed } from "@vue/composition-api";
import _ from "lodash";

export default defineComponent({
  props: {
    isSearch: Boolean,
    isStatus: Boolean,
    isAddTable: Boolean,
  },
  setup(props, { emit, root }) {
    const search = ref(null);
    const selectedStatusFilter = ref(null);
    const statusOptions = [
      {
        value: null,
        label: "All Status",
      },
      {
        value: "for_download",
        label: "Ready for download",
      },
      {
        value: "in_process",
        label: "In process",
      },
    ];
    const statusFilterDisplayText = computed(
      () =>
        statusOptions.find(
          (option) => option.value === selectedStatusFilter.value
        ).label
    );

    const applySearch = _.debounce(() => {
      const payload = {
        no_or_rows: 10,
      };
      if (!!search.value) payload["keyword"] = search.value;
      if (selectedStatusFilter.value)
        payload["file_status"] = selectedStatusFilter.value;
      emit("setPageSearch", payload);
    }, 300);

    watch(selectedStatusFilter, () => {
      applySearch();
    });

    const handleAddTable = () => {
      root.$router.push({ name: "DineInCreateTableGroup" });
    };

    return {
      search,
      selectedStatusFilter,
      statusOptions,
      statusFilterDisplayText,
      applySearch,
      handleAddTable,
    };
  },
});
</script>

<style lang="scss" scoped>
#dine-in-status-filter {
  box-shadow: 0 2px 4px 0 #e3e3e3;
}
.selected-icon-container {
  width: 12px;
}
</style>

